import { Controller } from '@hotwired/stimulus';

// 絞り込みフォームの変更を適用ボタンなしで即座に反映する
export default class extends Controller {
  static targets = ['columnsPicker'];

  // action="change->filter-form#submit"
  submit() {
    this.element.requestSubmit();
  }

  // action="toggle->filter-form#submitColumnsOnToggle"
  // 表示項目は複数まとめて選ぶため、1つずつではなくパネルを閉じたときに反映する
  submitColumnsOnToggle() {
    if (this.columnsPickerTarget.open) {
      this.columnsSnapshot = this.#checkedColumns();
      return;
    }

    if (
      this.columnsSnapshot !== undefined &&
      this.columnsSnapshot !== this.#checkedColumns()
    ) {
      this.submit();
    }
  }

  #checkedColumns() {
    return Array.from(
      this.columnsPickerTarget.querySelectorAll(
        'input[type="checkbox"]:checked',
      ),
    )
      .map((input) => input.value)
      .join(',');
  }
}
